import React, { useState } from 'react';
import './Home.css';




const Home = () => {
  const [showFullParagraph, setShowFullParagraph] = useState(false);

  
  const toggleParagraphVisibility = () => {
    
    setShowFullParagraph(!showFullParagraph);
  };

  return (
    <div>
       
      <div className="content">
      <div><h1 className="heading">ReproLoom</h1>
        <div className={`paragraph-container ${showFullParagraph ? 'expanded' : ''}`}>
          <p className="paragraph">
          ReproLoom is a cutting-edge mobile application revolutionizing the reprography experience for both users and shopkeepers. Tailored for seamless convenience, it empowers users to effortlessly upload articles for printing while specifying their unique preferences. With real-time updates and a streamlined tracking system, users can monitor the progress of their requests, ensuring a hassle-free experience. Simultaneously, ReproLoom provides a dedicated dashboard for shopkeepers, enhancing order management and operational 
          </p>
          <button id="load-more-button" onClick={toggleParagraphVisibility}>
            {showFullParagraph ? 'Show Less' : 'Load More'}
          </button>
        </div></div>
       
      </div>
    </div>
  );
};

export default Home;
